import {
  getEditorDivisionWithDivisionid,
  getEditorTeamWithTeamid,
  getTeamFontsWithTeamid
} from '../../api/cloudApiGenerated';

export const getEditorConfig = (team, division, anonymous) =>
  new Promise((resolve) => {
    if (division && division.id !== null) {
      return getEditorDivisionWithDivisionid(division.id).then((data) => {
        return resolve(data);
      });
    } else if (!anonymous) {
      return getEditorTeamWithTeamid(team.id).then((data) => {
        return resolve(data);
      });
    }
    return resolve();
  });

export const getCustomFonts = (team, anonymous) =>
  new Promise((resolve) => {
    if (!anonymous) {
      return getTeamFontsWithTeamid(team.id).then((data) => {
        if (data) {
          data.forEach((font) => {
            font.title = font.name;
            font.id = window.hcconfig.frontend.hostname + '/fonts/' + font.uuid + '/font.css';
          });
        }
        return resolve(data);
      });
    }
    return resolve();
  });

export const generateEditorSettings = async (team, division, anonymous, isThemeEditor) => {
  const customFonts = await getCustomFonts(team, anonymous);
  let data = await getEditorConfig(team, division, anonymous);

  let editorConfig = {
    features: 'data templates themes customize publish export help-cloud',
    useContextMenu: false,
    useHeader: false
  };

  if (data && data.length > 0) {
    editorConfig = JSON.parse(data[0].details);
    editorConfig.features = ' data ' + editorConfig.features + ' help-cloud';
    editorConfig.useContextMenu = false;
    editorConfig.useHeader = false;

    let config = editorConfig.customizer?.availableSettings;
    if (config) {
      config = config.map((d) => d.replaceAll('--', '.').replaceAll('-', '.'));
      editorConfig.customizer.availableSettings = config;
    }
  }

  if (customFonts) editorConfig.customFonts = customFonts;

  if (isThemeEditor) editorConfig.features = editorConfig.features.replace(' themes', '');
  return { editorConfig, data };
};
